import React, { useEffect, useRef, useState } from "react";
import { Container } from "react-bootstrap";
import { useCorporateCardRequestsStore } from "../../store/cardRequestsStore";
import svgCreditCard from "assets/credit_card.svg";
import "style/requests.css";
import CardRequestsTabs from "../CardRequests.Tabs/CardRequests.Tabs";
import { useParams, useNavigate } from "react-router-dom";
import { tabsData } from "../../constants";
import { userStore } from "entities/User/store/userStore";
import { useRequestPersistedStore } from "entities/Request";
import { ROLES } from "shared/config";

const CorporateCardRequestsContainer = (props) => {
  const cardFormat = props.cardFormat;
  const { key } = useParams();
  const navigate = useNavigate();

  const [authorizedTabs, setAuthorizedTabs] = useState(tabsData);
  const setViewRequestAs = useRequestPersistedStore(
    (state) => state.setViewRequestAs
  );
  const userData = useCorporateCardRequestsStore((state) => state.userData);
  const supervisorData = useCorporateCardRequestsStore(
    (state) => state.supervisorData
  );
  const additionalAcceptorData = useCorporateCardRequestsStore(
    (state) => state.additionalAcceptorData
  );

  const isUserSupervisor = userStore((state) => state.isUserSupervisor);
  const isUserCorporateCard = userStore((state) => state.isUserCorporateCard);
  const isUserAdditionalAcceptor = userStore(
    (state) => state.isUserAdditionalAcceptor
  );
  useEffect(() => {
    let newAuthorizedTabs = tabsData;

    if (!isUserSupervisor)
      newAuthorizedTabs = newAuthorizedTabs.filter(
        (tab) => tab.key !== "supervisor"
      );
    if (!isUserAdditionalAcceptor)
      newAuthorizedTabs = newAuthorizedTabs.filter(
        (tab) => tab.key !== "additional-acceptor"
      );

    setAuthorizedTabs(newAuthorizedTabs);
  }, [isUserSupervisor, isUserAdditionalAcceptor]);

  const getUserData = useCorporateCardRequestsStore(
    (state) => state.getUserData
  );
  const getSupervisorData = useCorporateCardRequestsStore(
    (state) => state.getSupervisorData
  );
  const getAdditionalAcceptorData = useCorporateCardRequestsStore(
    (state) => state.getAdditionalAcceptorData
  );

  const userError = useCorporateCardRequestsStore((state) => state.userError);
  const supervisorError = useCorporateCardRequestsStore(
    (state) => state.supervisorError
  );
  const additionalAcceptorError = useCorporateCardRequestsStore(
    (state) => state.additionalAcceptorError
  );

  const loading = useCorporateCardRequestsStore((state) => state.loading);
  const setLoading = useCorporateCardRequestsStore((state) => state.setLoading);

  const error = useCorporateCardRequestsStore((state) => state.error);
  const setError = useCorporateCardRequestsStore((state) => state.setError);

  const errorKey = useCorporateCardRequestsStore((state) => state.errorKey);
  const setErrorKey = useCorporateCardRequestsStore(
    (state) => state.setErrorKey
  );

  const dataKey = useCorporateCardRequestsStore((state) => state.dataKey);
  const setDataKey = useCorporateCardRequestsStore((state) => state.setDataKey);

  const data = useCorporateCardRequestsStore((state) => state.data);
  const setData = useCorporateCardRequestsStore((state) => state.setData);

  const fetchData = async () => {
    setLoading(true);

    if (key === "user") {
      setViewRequestAs({ role: ROLES.USER });
      await getUserData();
    }
    if (key === "supervisor") {
      setViewRequestAs({ role: ROLES.SUPERVISOR });
      await getSupervisorData();
    }
    if (key === "additional-acceptor") {
      setViewRequestAs({ role: ROLES.ADDITIONAL_ACCEPTOR });
      await getAdditionalAcceptorData();
    }
  };

  useEffect(() => {
    if (!tabsData.some((tab) => tab.key === key)) navigate("/");
    fetchData();
    //eslint-disable-next-line
  }, [key]);

  const didMountRef = useRef(false);

  useEffect(() => {
    if (key === "user") {
      setData(userData);
    }
    if (key === "supervisor") {
      setData(supervisorData);
    }
    if (key === "additional-acceptor") {
      setData(additionalAcceptorData);
    }
    setDataKey(key);

    if (didMountRef.current) {
      if (key === dataKey) setLoading(false);
    } else {
      didMountRef.current = true;
    }
    //eslint-disable-next-line
  }, [userData, supervisorData, additionalAcceptorData]);

  useEffect(() => {
    if (key === "user") {
      if (userError.length) {
        setErrorKey("user");
        setError(userError);
      } else {
        setError("");
      }
    }
    if (key === "supervisor") {
      if (supervisorError.length) {
        setErrorKey("supervisor");
        setError(supervisorError);
      } else {
        setError("");
      }
    }
    if (key === "additional-acceptor") {
      if (additionalAcceptorError.length) {
        setErrorKey("additional-acceptor");
        setError(supervisorError);
      } else {
        setError("");
      }
    }
    //eslint-disable-next-line
  }, [key, userError, supervisorError, additionalAcceptorError]);

  useEffect(() => {
    if (error.length) setLoading(false);
    //eslint-disable-next-line
  }, [error]);

  return (
    <Container fluid className="container_requests">
      <h3 className="h3_requests">
        <img
          className="h3_img_requests"
          src={svgCreditCard}
          alt="request icon"
        />
        Card Expenses
      </h3>
      <CardRequestsTabs
        {...{
          tabs: authorizedTabs,
          data,
          loading,
          error,
          dataKey,
          errorKey,
          cardFormat,
        }}
      />
    </Container>
  );
};

export default CorporateCardRequestsContainer;
